module.exports = "./img/a771550b224c771e1935e25bfba0e895.png";